import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import { MensajeError, MensajeInfo } from "../../componentes/FuncionesLocales";
import { asegurarConfiguracionPc } from "../../servicios/configuracionPc";
import { invalidarCacheClientes } from "../../servicios/clientes";
import { guardarSesion, limpiarSesion, obtenerSesion } from "../../servicios/sesionSeguridad";

const credencialValida = (valor) => {
  const texto = String(valor || "").trim().toLowerCase();
  return Boolean(texto && texto !== "undefined" && texto !== "null");
};

export const useStoreLogin = create((set, get) => {
  const inicial = obtenerSesion();
  return {
    EmpresaId: inicial?.EmpresaId || Number(localStorage.getItem("EmpresaId")) || 0,
    Mail: inicial?.Mail || localStorage.getItem("Mail") || "",
    Password: "",
    Id: inicial?.IdentidadId || 0,
    BuscandoOperador: false,
    LoginOk: Boolean(inicial),
    YaRegistroBitacora: false,
    Registrando: false,

    isAuthenticated: () => {
      const sesion = obtenerSesion();
      return Boolean(sesion?.EmpresaId && sesion?.IdentidadId);
    },

    validarVariablesGlobales: () => {
      const sesion = obtenerSesion();
      return Boolean(sesion?.EmpresaId && sesion?.IdentidadId);
    },

    validarOperador: async () => {
      if (get().BuscandoOperador) return;
      const Mail = String(get().Mail || "").trim();
      const PassWord = get().Password;
      if (!credencialValida(Mail) || !credencialValida(PassWord)) {
        await MensajeError("Correo electrónico y contraseña son obligatorios.");
        return;
      }

      set({ BuscandoOperador: true });
      try {
        const respuesta = await _Componentes_WebApiCalls_Post("PISeunLogin/ValidarOperador", {
          Mail, PassWord,
        });
        if (respuesta.error) {
          await MensajeError(respuesta.error);
          return;
        }
        const sesion = guardarSesion(respuesta.data);
        const empresaAnterior = useStoreHome.getState().EmpresaId;
        if (empresaAnterior !== sesion.EmpresaId) invalidarCacheClientes();
        useStoreHome.setState({ EmpresaId: sesion.EmpresaId });
        await asegurarConfiguracionPc(sesion.EmpresaId);
        set({
          EmpresaId: sesion.EmpresaId,
          Mail: sesion.Mail || Mail,
          Password: "",
          Id: sesion.IdentidadId,
          LoginOk: true,
        });
      } catch (error) {
        limpiarSesion();
        await MensajeError(error.message || "No se pudo iniciar sesión.");
      } finally {
        set({ BuscandoOperador: false, Password: "" });
      }
    },

    logout: async ({ notificarServidor = true } = {}) => {
      const sesion = obtenerSesion();
      try {
        if (notificarServidor && sesion?.RefreshToken) {
          await _Componentes_WebApiCalls_Post("PISeunLogin/Logout", {
            EmpresaId: sesion.EmpresaId,
            RefreshToken: sesion.RefreshToken,
          });
        }
      } finally {
        invalidarCacheClientes();
        limpiarSesion();
        useStoreHome.setState({ EmpresaId: 0 });
        set({ EmpresaId: 0, Mail: "", Password: "", Id: 0, LoginOk: false, BuscandoOperador: false, YaRegistroBitacora: false });
        if (typeof window !== "undefined") window.location.href = "/login";
      }
    },

    EnvioPasswordMensaje: "",
    EnvioPasswordError: "",
    envioPassword: async () => {
      if (!get().Mail) {
        MensajeInfo("El correo electrónico es obligatorio");
        return;
      }
      set({ BuscandoOperador: true });
      const respuesta = await _Componentes_WebApiCalls_Post("PISeunLogin/EnvioPassword", { Email: get().Mail });
      set(respuesta.error
        ? { EnvioPasswordError: respuesta.error, BuscandoOperador: false }
        : { EnvioPasswordMensaje: "Se ha enviado la contraseña a su correo electrónico", BuscandoOperador: false });
    },

    bitacoraOperadores: async () => {
      if (get().YaRegistroBitacora) return;
      set({ YaRegistroBitacora: true });
      try {
        let deviceInfo = useStoreHome.getState().deviceInfo || null;
        if (!deviceInfo) {
          try { deviceInfo = JSON.parse(localStorage.getItem("deviceInfo") || "null"); } catch { deviceInfo = null; }
        }
        await _Componentes_WebApiCalls_Post("PISeunLogin/BitacoraOperadores", {
          nLatitud: deviceInfo?.browserLocation?.latitude ?? 0,
          nLongitud: deviceInfo?.browserLocation?.longitude ?? 0,
          nAccuracy: deviceInfo?.browserLocation?.accuracy ?? 0,
          sUbicacion: deviceInfo?.ubicacionTexto ?? "",
          sPlataforma: deviceInfo?.plataforma ?? "",
          sEstado: deviceInfo?.estado ?? "",
          sIp: deviceInfo?.ip ?? "",
          sIPLocal: deviceInfo?.localIP ?? "",
        });
      } catch {
        set({ YaRegistroBitacora: false });
      }
    },

    registroAcceso: async (ip) => {
      // RegistroAccesos requiere autenticación en la API actual. No debe
      // invocarse desde la pantalla pública de login.
      if (!ip || !obtenerSesion() || get().Registrando) return;
      try {
        set({ Registrando: true });
        await _Componentes_WebApiCalls_Post("PISeunLogin/RegistroAccesos", { sIp: ip });
      } finally {
        set({ Registrando: false });
      }
    },
  };
});
